import { getRTL } from 'office-ui-fabric-react';
export var getRTLFlipOptOut = function () {
    return getRTL() ? '@noflip' : '';
};
//# sourceMappingURL=rtlOptOut.js.map